export function Filament() {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        width: "100%",
        marginTop: "8px",
      }}
    >
      <div style={{ width: "100%" }}>
        <iframe
          title="Filament"
          className="airtable-embed"
          src="https://airtable.com/embed/appdpv538daQHS2Tj/shrm0vC1HoiWnBWWI"
          width="100%"
          height="800"
          style={{ background: "transparent" }}
        ></iframe>
      </div>
    </div>
  );
}
